export default "__VITE_PUBLIC_ASSET__a7266308__"